import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {TemplateResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    vmTemplates: TemplateResponse[];
     authenticated: boolean;
}

const initialState: State = {
    vmTemplates: [],
    authenticated:false
};

const VmTemplatesSlice = createSlice({
    name: 'vmTemplates',
    initialState,
    reducers: {
        SET_VMTEMPLATES(state, { payload }: PayloadAction<TemplateResponse[]>) {
            state.vmTemplates = payload;
        },
            DELETE_COMPONENTS_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.vmTemplates)) {
                state.vmTemplates = [];
            }

            state.vmTemplates = state.vmTemplates.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },
     DELETE_VMTEMPLATE_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.vmTemplates)) {
                state.vmTemplates = [];
            }

            state.vmTemplates = state.vmTemplates.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },
        ADD_VMTEMPLATES(state, { payload }: PayloadAction<TemplateResponse>) {
            const newScripts = [...state.vmTemplates, payload];
            state.vmTemplates = newScripts;
        },
        PATCH_VMTEMPLATES(state, { payload }: PayloadAction<TemplateResponse>) {
            const newCloudEnvironment = [...state.vmTemplates];
            const findInd = newCloudEnvironment.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newCloudEnvironment[findInd] = { ...payload };
            state.vmTemplates = newCloudEnvironment;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectVmTemplates = (state: RootState) => state.script;

export const { SET_VMTEMPLATES,DELETE_VMTEMPLATE_BYID, DELETE_COMPONENTS_BYID, ADD_VMTEMPLATES, PATCH_VMTEMPLATES,SET_AUTHENTICATED } =
    VmTemplatesSlice.actions;

export default VmTemplatesSlice.reducer;
